module.exports = __webpack_public_path__ + "static/infrastructure_costs-7f414505399f045f477898ea66eea8d4.svg";